
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmPipControl,
  VmControl,
  VmIcon,
  VmTooltip 
} from '@vime/core';

import { define } from '../lib';
  

const PipControlInputs: string[] = [
  'enterIcon',
  'exitIcon',
  'icons',
  'tooltipPosition',
  'tooltipDirection',
  'hideTooltip',
  'keys',
  'isPiPActive',
  'i18n',
  'playbackReady',
];

const PipControlMethods: string[] = [
  
];

const PipControlOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface PipControl extends Components.VmPipControl {}

@ProxyCmp({
  inputs: PipControlInputs,
  methods: PipControlMethods,
})
@Component({
  selector: 'vm-pip-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: PipControlInputs,
  outputs: PipControlOutputs,
})
export class PipControl {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-pip-control', VmPipControl);
    define('vm-control', VmControl);
    define('vm-icon', VmIcon);
    define('vm-tooltip', VmTooltip);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  